module.exports = __webpack_public_path__ + "static/media/2025_scholorship.2c0da76e.jpg";